import React from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { Divider } from '@material-ui/core'
import { FiCheck, FiX } from 'react-icons/fi'
import { Color } from '../../ColorPalette'
import { theme } from '../../../theme'
import Label from './Label'
import State from './State'

function LimitItem({
  label,
  icon,
  state,
  limit,
  info = false,
}: ILimitItemProps) {
  const { t } = useTranslation()
  const unavailable = !info && state >= limit

  return (
    <Flex full={true} column={true} style={{ minHeight: '50px' }}>
      <Flex full={true} alignStretch={true}>
        <Flex alignCenter={true} style={{ margin: '5px 0px', width: '60%' }}>
          <Color
            width={'32px'}
            height={'32px'}
            color={unavailable ? '#f70011' : theme.colors.palette.emerald}
            style={{
              marginLeft: '0px',
              maxHeight: '32px',
              maxWidth: '32px',
              minHeight: '32px',
              minWidth: '32px',
            }}
          >
            {icon}
          </Color>
          <Label>{label}</Label>
        </Flex>
        <Flex
          alignCenter={true}
          justifyCenter={true}
          style={{ minWidth: '90px', width: '20%' }}
        >
          {typeof limit === 'boolean' ? (
            <Color
              width={'32px'}
              height={'32px'}
              color={'#f70011'}
              style={{
                maxHeight: '32px',
                maxWidth: '32px',
                minHeight: '32px',
                minWidth: '32px',
              }}
            >
              <FiX size={20} />
            </Color>
          ) : (
            <State exceeded={unavailable}>{`${state}${info ? '*' : ''} ${
              !info ? t('z677_of') : ''
            } ${!info ? limit : ''}`}</State>
          )}
        </Flex>
        <Flex
          alignCenter={true}
          justifyCenter={true}
          style={{
            background: theme.colors.palette.paleGrey,
            minWidth: '90px',
            width: '20%',
          }}
        >
          {typeof limit === 'boolean' ? (
            <Color
              width={'32px'}
              height={'32px'}
              color={theme.colors.palette.emerald}
              style={{
                maxHeight: '32px',
                maxWidth: '32px',
                minHeight: '32px',
                minWidth: '32px',
              }}
            >
              <FiCheck size={20} />
            </Color>
          ) : (
            <State style={{ color: '#02a642', height: '100%' }}>
              {t('unlimited')}
            </State>
          )}
        </Flex>
      </Flex>
      <Divider />
    </Flex>
  )
}

export default LimitItem

export interface ILimitItemProps {
  label: string
  icon: React.ReactNode | JSX.Element
  state: number | boolean
  limit: number | boolean
  info?: boolean
}
